import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Apresentacao";
import PublicHome from "@/pages/PublicHome";
import PublicStreamPage from "@/pages/PublicStreamPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppShell from "@/components/AppShell";
import ExplorePage from "@/pages/ExplorePage";
import ServerPage from "@/pages/ServerPage";
import CreatorPage from "@/pages/CreatorPage";
import StreamPage from "@/pages/StreamPage";
import SettingsPage from "@/pages/SettingsPage";
import HomePage from "@/pages/HomePage";
import CommunitiesPage from "@/pages/CommunitiesPage";
import CategoriesPage from "@/pages/CategoriesPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono text-sm text-muted-foreground">carregando nexus live…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/apresentacao" element={<Landing />} />
          <Route path="/live/:streamId" element={<PublicStreamPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/app"
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="explorar" element={<ExplorePage />} />
            <Route path="comunidades" element={<CommunitiesPage />} />
            <Route path="categorias" element={<CategoriesPage />} />
            <Route path="servidor/:serverId" element={<ServerPage />} />
            <Route path="servidor/:serverId/canal/:channelId" element={<ServerPage />} />
            <Route path="criador/:username" element={<CreatorPage />} />
            <Route path="live/:streamId" element={<StreamPage />} />
            <Route path="configuracoes" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </AuthProvider>
  );
}
